import { instance } from '@payments-checkout/shared/helpers/service/instance.service';
import {
  useQuery
} from '@tanstack/react-query';

import { useParams } from 'next/navigation';
import { usePageSharedData } from '../../hooks/usePageSharedData';
import { mapAllowedPaymentMethods } from '../helpers/mapAllowedPaymentMethods.helper';
import { GooglePayData } from '../types/googlePayData.types';



async function getGooglePayData(paymentLinkId: string) {
  const response = await instance.get(
    `paymentlinks/${paymentLinkId}/digital-wallets/google_pay`
  );

  return response.data;
}

const useGooglePay = (paymentLinkId: string) => {
  return useQuery({
    queryKey: ['getGooglePayData', paymentLinkId],
    queryFn: () => getGooglePayData(paymentLinkId),
    staleTime: Infinity,
    enabled: !!paymentLinkId,
  });
};

function useGooglePayData() {
  const { paymentLinkId } = useParams<{ paymentLinkId: string }>();
  const { data, isSuccess, isLoading } = useGooglePay(paymentLinkId);
  const { total } = usePageSharedData();

  if (!isSuccess || !data) {
    return {
      isSuccess: false,
      isLoading,
      paymentRequest: null,
      googlePayData: null,
    };
  }

  const googlePayData: GooglePayData = data.google_pay;
  const allowedPaymentMethods = mapAllowedPaymentMethods(
    googlePayData.allowed_payment_methods
  );

  const paymentRequest = {
    emailRequired: true,
    apiVersion: googlePayData.api_version,
    apiVersionMinor: googlePayData.api_version_minor,
    allowedPaymentMethods: allowedPaymentMethods,
    merchantInfo: {
      merchantId: googlePayData.merchant_info.merchant_id,
    },
    shippingOptionRequired: false,
    transactionInfo: {
      totalPriceStatus: googlePayData.transaction_info.total_price_status,
      totalPriceLabel: googlePayData.transaction_info.total_price_label,
      totalPrice: total.amount.toString().slice(0, -2),
      currencyCode: googlePayData.transaction_info.currency_code,
      countryCode: googlePayData.transaction_info.country_code,
    },
    callbackIntents: ['PAYMENT_AUTHORIZATION'],
  };

  return { isSuccess, isLoading, paymentRequest, googlePayData };
}
export { getGooglePayData, useGooglePay, useGooglePayData };
